import { Descriptions } from 'antd';
import { changesDictionary } from '../../../../constants/Diary.const';

export const ChangesModalBody = ({ data }) => {
  const getChanges = () => {
    if (!data) return {};
    if (typeof data === 'object') return data;

    try {
      return JSON.parse(data);
    } catch {
      return {};
    }
  };

  const changes = getChanges();
  return (
    <>
      <Descriptions bordered>
        <Descriptions.Item label={'Cambios'} style={{ width: '30%' }}>
          Antes
        </Descriptions.Item>
        <Descriptions.Item>Despues</Descriptions.Item>
      </Descriptions>

      {Object.entries(changes).map(([key, value]) => (
          <Descriptions key={key} bordered>
            <Descriptions.Item
              label={changesDictionary[key]}
              style={{ width: '30%' }}
            >
              {value?.before
                ? changesDictionary[value?.before]
                  ? changesDictionary[value?.before]
                  : value?.before
                : '-'}
            </Descriptions.Item>
            <Descriptions.Item>
              {value?.after
                ? changesDictionary[value?.after]
                  ? changesDictionary[value?.after]
                  : value?.after
                : '-'}
            </Descriptions.Item>
          </Descriptions>
      ))}
    </>
  );
};
